export default {
    translation: {
        breadcrumbs: {
            '404': '404',
            '500': '500',
            'app': 'アプリ',
            'horizontal': '水平',
            'horizontalMenu': '水平メニュー',
            'general': '一般',
            'component': '成分',
            'features': '特徴',
            'applications': 'アプリケーション',
            'dashboard': 'ダッシュボード',
            'dashboard1': 'ダッシュボード1',
            'dashboard2': 'ダッシュボード2',
            'dashboard3': 'ダッシュボード3',
            'modules': 'モジュール',
            'agency': '代理店',
            'pages': 'ページ',
            'gallery': 'ギャラリー',
            'pricing': '価格設定',
            'terms&Conditions': '利用規約',
            'feedback': 'フィードバック',
            'report': '報告する',
            'faq(s)': 'Faq（s）',
            'advancedComponent': 'アドバンスコンポーネント',
            'blank': 'ブランク',
            'session': 'セッション',
            'login': 'ログイン',
            'register': '登録',
            'lockScreen': 'ロック画面',
            'forgotPassword': 'パスワードをお忘れですか',
            'uiComponents': 'UIコンポーネント',
            'alerts': 'アラート',
            'appBar': 'アプリバー',
            'avatars': 'アバター',
            'buttons': 'ボタン',
            'bottomNavigations': 'ボトムナビゲーション',
            'badges': 'バッジ',
            'cards': 'カード',
            'cardsMasonry': 'カードマセナリー',
            'chip': 'チップ',
            'dialog': 'ダイアログ',
            'dividers': '仕切り',
            'drawers': '引き出し',
            'popover': 'ポップオーバー',
            'expansionPanel': '拡張パネル',
            'gridList': 'グリッドリスト',
            'list': 'リスト',
            'menu': 'メニュー',
            'popoverAndToolTip': 'ポップ＆ツールヒント',
            'progress': '進捗',
            'snackbar': 'スナックバー',
            'selectionControls': '選択コントロール',
            'advanceUiComponents': 'アドバンスUIコンポーネント',
            'dateAndTimePicker': '日付と時刻のピッカー',
            'tabs': 'タブ',
            'stepper': 'ステッパー',
            'notification': 'お知らせ',
            'sweetAlert': 'スウィートアラート',
            'autoComplete': 'オートコンプリート',
            'aboutUs': '私たちに関しては',
            'widgets': 'ウィジェット',
            'forms': 'フォーム',
            'formElements': 'フォーム要素',
            'textField': 'テキストフィールド',
            'selectList': 'リストを選択',
            'charts': 'チャート',
            'reCharts': 'リチャート',
            'reactChartjs2': '反応チャート2',
            'icons': 'アイコン',
            'themifyIcons': 'テーマアイコン',
            'simpleLineIcons': 'シンプルラインアイコン',
            'materialIcons': 'マテリアルアイコン',
            'fontAwesome': 'フォント驚くばかり',
            'tables': 'テーブル',
            'basic': 'ベーシック',
            'dataTable': 'データ表',
            'responsive': '応答性のある',
            'reactTable': '反応表',
            'maps': '地図',
            'googleMaps': 'グーグルマップ',
            'leafletMaps': 'リーフレットマップ',
            'inbox': '受信トレイ',
            'users': 'ユーザー',
            'userProfile1': 'ユーザープロファイル1',
            'userProfile2': 'ユーザープロファイル2',
            'userManagement': 'ユーザー管理',
            'userProfile': 'ユーザープロファイル',
            'userList': 'ユーザーリスト',
            'calendar': 'カレンダー',
            'cultures': '文化',
            'dnd': 'Dnd',
            'selectable': '選択可能',
            'customRendering': 'カスタムレンダリング',
            'chat': 'チャット',
            'toDo': 'ToDo',
            'editor': '編集者',
            'wysiwygEditor': 'WYSIWYGエディタ',
            'quillEditor': 'クイルエディタ',
            'reactAce': 'リアクションエース',
            'dragAndDrop': 'ドラッグアンドドロップ',
            'reactDragula': '反撃ドラゴン',
            'reactDnd': '反応Dnd',
            'blogManagement': 'ブログ管理',
            'ecommerce': 'eコマース',
            'shopList': 'ショップリスト',
            'shopGrid': 'ショップグリッド',
            'invoice': '請求書',
            'multilevel': 'マルチレベル',
            'sublevel': 'サブレベル',
            'dateTimePicker': '日付と時刻のピッカー',
            'user': 'ユーザー',
            'miscellaneous': '雑',
            'promo': 'プロモーション',
            'gettingStarted': '入門',
            'shop': 'ショップ',
            'cart': 'カート',
            'checkout': 'チェックアウト',
            'saas': 'SAAS',
            'multiLevel': 'マルチレベル',
            'level1': 'レベル1',
            'level2': 'レベル2',
            'boxed': '箱入り',
            'news': 'ニュース',
            'extensions': '拡張機能',
            'imageCropper': 'Image Cropper',
            'videoPlayer': 'ビデオプレーヤー',
            'dropzone': 'Dropzone',
            'crm': 'CRM',
            'projects': 'プロジェクト',
            'projectDetail': 'プロジェクト詳細',
            'clients': 'クライアント',
            'reports': '報告書'
        },
        'widgets': {
            'totalEarns': '総収入',
            'emailsStatistics': 'メール統計',
            'totalRevenue': '総収入',
            'onlineVistors': 'オンラインバリスタ',
            'trafficSources': 'トラフィックソース',
            'RecentOrders': '最近の注文',
            'topSellings': 'トップセリング',
            'productReports': '製品レポート',
            'productStats': '製品の統計',
            'ratings': '評価',
            'ComposeEmail': 'Eメールの作成',
            'employeePayroll': '従業員の給与計算',
            'visitors': '訪問者',
            'orders': '注文',
            'orderStatus': '注文の状況',
            'totalSales': 'トータルセールス',
            'netProfit': '純利益',
            'overallTrafficStatus': '全体のトラフィック状況',
            'tax': '税金',
            'expenses': '経費',
            'currentTime': '現在の時刻',
            'currentDate': '現在の日付',
            'todayOrders': '今日の注文',
            'toDoList': 'To Doリスト',
            'discoverPeople': '人々を発見する',
            'commments': 'コメント',
            'newCustomers': '新しいお客様',
            'recentNotifications': '最近のお知らせ',
            'appNotifications': 'アプリの通知',
            'newEmails': '新しいメール',
            'siteVisitors': 'サイト訪問者',
            'socialCompanines': 'ソーシャルコンパニオン',
            'recentActivities': '最近の活動',
            'recentOrders': '最近の注文',
            'gallery': 'ギャラリー',
            'pricing': '価格設定',
            'enterpriseEdition': 'エンタープライズ版',
            'personalEdition': 'パーソナルエディション',
            'teamEdition': 'チーム版',
            'standard': '標準',
            'advanced': '上級',
            'master': 'マスター',
            'Mega': 'メガ',
            'logIn': 'ログイン',
            'signUp': 'サインアップ',
            'lockScreen': 'ロック画面',
            'alertsWithLink': 'リンク付きアラート',
            'additionalContent': '追加コンテンツ',
            'alertDismiss': 'アラート終了',
            'uncontrolledDisableAlerts': '制御されていないディセーブルアラート',
            'contexualAlerts': 'コンテンツアラート',
            'alertsWithIcons': 'アイコン付きアラート',
            'Simple App Bars': 'シンプルなアプリケーションバー',
            'appBarsWithButtons': 'ボタン付きのアプリケーションバー',
            'imageAvatars': 'イメージアバター',
            'lettersAvatars': '手紙アバター',
            'iconsAvatars': 'アイコンアバター',
            'flatButtons': 'フラットボタン',
            'raisedButton': '上げたボタン',
            'buttonWithIconAndLabel': 'アイコンとラベルのボタン',
            'floatingActionButtons': 'フローティングアクションボタン',
            'iconButton': 'アイコンボタン',
            'socialMediaButton': 'ソーシャルメディアボタン',
            'reactButton': 'リアクションボタン',
            'buttonOutline': 'ボタンの概要',
            'buttonSize': 'ボタンのサイズ',
            'buttonState': 'ボタンの状態',
            'buttonNavigationWithNoLabel': 'ラベルなしのボタンナビゲーション',
            'buttonNavigation': 'ボタンナビゲーション',
            'iconNavigation': 'アイコンナビゲーション',
            'badgeWithHeadings': '見出しのバッジ',
            'contexualVariations': '文脈のバリエーション',
            'badgeLinks': 'バッジリンク',
            'materialBadge': 'マテリアルバッジ',
            'simpleCards': 'シンプルカード',
            'backgroundVarient': '背景バリエント',
            'cardOutline': 'カード概要',
            'overlayCard': 'オーバーレイカード',
            'cardGroup': 'カードグループ',
            'cardTitle': 'カードタイトル',
            'speacialTitleTreatment': '広場タイトル治療',
            'chipWithClickEvent': 'クリックイベントのチップ',
            'chipArray': 'チップアレイ',
            'dialogs': 'ダイアログ',
            'listDividers': 'リストディバイダ',
            'insetDividers': 'インセットディバイダー',
            'temporaryDrawers': '一時的な引き出し',
            'permanentDrawers': '常設引き出し',
            'simpleExpansionPanel': 'シンプルな拡張パネル',
            'controlledAccordion': '制御アコーデオン',
            'secondaryHeadingAndColumns': '二次見出しと柱',
            'imageOnlyGridLists': '画像のみのグリッドリスト',
            'advancedGridLists': '高度なグリッドリスト',
            'singleLineGridLists': '単線グリッドリスト',
            'simpleLists': 'シンプルリスト',
            'folderLists': 'フォルダ一覧',
            'listItemWithImage': '画像付きアイテムの一覧表示',
            'switchLists': 'スイッチリスト',
            'insetLists': 'インセットリスト',
            'nestedLists': 'ネストされたリスト',
            'checkboxListControl': 'チェックボックスリストコントロール',
            'pinedSubHeader': 'Pinedサブヘッダー',
            'InteractiveLists': 'インタラクティブリスト',
            'simpleMenus': 'シンプルメニュー',
            'selectedMenu': '選択されたメニュー',
            'maxHeightMenu': '最大高さメニュー',
            'changeTransition': '移行を変更する',
            'paper': '紙',
            'anchorPlayGround': 'アンカープレーグラウンド',
            'tooltip': 'ツールヒント',
            'positionedToolTips': '位置付けられたスナックバー',
            'circularProgressBottomStart': '円形進捗ボトムスタート',
            'interactiveIntegration': 'インタラクティブな統合',
            'determinate': '決定する',
            'linearProgressLineBar': '線形進行線バー',
            'indeterminate': '不確定',
            'buffer': 'バッファ',
            'query': 'クエリ',
            'transitionControlDirection': '移行制御方向',
            'simpleSnackbar': 'シンプルなスナックバー',
            'positionedSnackbar': '位置付けられたスナックバー',
            'contexualColoredSnackbars': 'コンテクストカラーのスナックバー',
            'simpleCheckbox': '簡易チェックボックス',
            'interminateSelection': '間欠選択',
            'disabledCheckbox': '無効なチェックボックス',
            'customColorCheckbox': 'カスタムカラーチェックボックス',
            'VerticalStyleCheckbox': '垂直スタイルのチェックボックス',
            'horizontalStyleCheckbox': '水平スタイルチェックボックス',
            'radioButtons': 'ラジオボタン',
            'disabledRadio': '障害者用ラジオ',
            'withError': 'エラーあり',
            'switches': 'スウィッチ',
            'dateAndTimePicker': '日付と時刻のピッカー',
            'defaultPicker': 'デフォルトのピッカー',
            'timePicker': '時間ピッカー',
            'weekPicker': '週ピッカー',
            'defaultDatePicker': 'デフォルトの日付ピッカー',
            'customPicker': 'カスタムピッカー',
            'tabs': 'タブ',
            'fixedTabs': '固定タブ',
            'basicTab': '基本タブ',
            'wrappedLabels': 'ラップラベル',
            'centeredLabels': '中央のラベル',
            'forcedScrolledButtons': '強制スクロールボタン',
            'iconsTabs': 'アイコンタブ',
            'withDisableTabs': 'タブを無効にする',
            'iconWithLabel': 'ラベル付きアイコン',
            'stepper': 'ステッパー',
            'horizontalLinear': '水平リニア',
            'horizontalNonLinear': '水平非線形',
            'horizontalLinerAlternativeLabel': '水平ライナー代替ラベル',
            'horizontalNonLinerAlternativeLabel': '水平ノンライナー代替ラベル',
            'verticalStepper': '垂直ステッパー',
            'descriptionAlert': '説明アラート',
            'customIconAlert': 'カスタムアイコンアラート',
            'withHtmlAlert': 'HTMLアラートで',
            'promptAlert': '迅速な警告',
            'passwordPromptAlert': 'パスワードプロンプトアラート',
            'customStyleAlert': 'カスタムスタイルアラート',
            'autoComplete': 'オートコンプリート',
            'reactSelect': '反応選択',
            'downshiftAutoComplete': 'ダウンシフトオートコンプリート',
            'reactAutoSuggests': 'オート提案の提案',
            'aboutUs': '私たちに関しては',
            'ourVission': '私たちの使命',
            'ourMissions': '私たちの使命',
            'ourMotivation': '私たちのモチベーション',
            'defualtReactForm': '不確定な反応形式',
            'url': 'Url',
            'textArea': 'テキスト領域',
            'file': 'ファイル',
            'formGrid': 'フォームグリッド',
            'inlineForm': 'インラインフォーム',
            'inputSizing': '入力サイジング',
            'inputGridSizing': '入力グリッドサイジング',
            'hiddenLabels': '隠しラベル',
            'formValidation': 'フォーム検証',
            'number': '数',
            'date': '日付',
            'time': '時間',
            'color': '色',
            'search': 'サーチ',
            'selectMultiple': '複数を選択',
            'inputWithSuccess': '成功の入力',
            'inputWithDanger': '危険を伴う入力',
            'simpleTextField': 'シンプルテキストフィールド',
            'componet': 'コンポーネント',
            'layouts': 'レイアウト',
            'inputAdorements': '入力アドライト',
            'formattedInputs': '書式付き入力',
            'simpleSelect': 'シンプルセレクト',
            'nativeSelect': 'ネイティブセレクト',
            'MutltiSelectList': '複数選択 リスト',
            'lineChart': '折れ線グラフ',
            'barChart': '棒グラフ',
            'stackedBarChart': '積み上げ棒グラフ',
            'lineBarAreaChart': 'ラインバーエリアチャート',
            'areaChart': 'エリアチャート',
            'stackedAreaChart': '積み重ねられたエリアチャート',
            'verticalChart': '垂直チャート',
            'radarChart': 'レーダーチャート',
            'doughnut': 'ドーナツ',
            'polarChart': '極座標',
            'pieChart': '円グラフ',
            'bubbleChart': 'バブルチャート',
            'horizontalBar': 'ホライズンナショナル バー',
            'basicTable': '基本テーブル',
            'contexualColoredTable': 'コンテクスチャカラーテーブル',
            'dataTable': 'データ表',
            'employeeList': '従業員リスト',
            'responsiveTable': 'レスポンシブテーブル',
            'responsiveFlipTable': '応答性フリップテーブル',
            'reactGridControlledStateMode': 'グリッド制御状態モードに反応する',
            'googleMaps': 'グーグルマップ',
            'productsReports': '製品レポート',
            'taskList': 'タスクリスト',
            'basicCalender': '基本的なカレンダー',
            'culturesCalender': 'カルチャーカレンダー',
            'dragAndDropCalender': 'ドラッグアンドドロップカレンダー',
            'selectableCalender': '選択可能なカレンダー',
            'customRendering': 'カスタムレンダリング',
            'customCalender': 'カスタムカレンダー',
            'searchMailList': 'メールリストを検索',
            'forgetPassword': 'パスワードを忘れる',
            'QuickLinks': 'クイックリンク',
            'upgrade': 'アップグレード',
            'app': 'アプリ',
            'addNew': '新しく追加する',
            'orderDate': '注文日',
            'status': '状態',
            'trackingNumber': '追跡番号',
            'action': 'アクション',
            'designation': '指定',
            'subject': '主題',
            'send': '送信',
            'saveAsDrafts': '下書きとして保存',
            'onlineSources': 'オンラインソース',
            'lastMonth': '先月',
            'widgets': 'ウィジェット',
            'listing': 'リスト',
            'paid': '有料',
            'refunded': '払い戻された',
            'done': '完了',
            'pending': '保留中',
            'cancelled': 'キャンセル',
            'approve': '承認する',
            'following': '以下',
            'follow': 'フォローする',
            'graphs&Charts': 'グラフ＆グラフ',
            'open': '開いた',
            'bounced': 'バウンス',
            'spam': 'スパム',
            'unset': '設定を解除する',
            'bandwidthUse': '帯域幅の使用',
            'dataUse': 'データ使用',
            'unsubscribe': '退会する',
            'profile': 'プロフィール',
            'messages': 'メッセージ',
            'support': 'サポート',
            'faq(s)': 'Faq（s）',
            'upgradePlains': 'アップグレードプレーンズ',
            'logOut': 'ログアウト',
            'mail': '郵便物',
            'adminTheme': '管理テーマ',
            'wordpressTheme': 'Wordpressのテーマ',
            'addToCart': 'カートに追加',
            'plan': '計画',
            'basic': 'ベーシック',
            'pro': 'プロ',
            'startToBasic': 'ベーシックスタート',
            'upgradeToPro': 'プロ仕様にアップグレードする',
            'upgradeToAdvance': 'アドバンスにアップグレードする',
            'comparePlans': '計画比較',
            'free': '無料',
            'frequentlyAskedQuestions': 'よくある質問',
            'searchIdeas': '検索のアイデア',
            'startDate': '開始日',
            'endDate': '終了日',
            'category': 'カテゴリー',
            'apply': '適用',
            'downloadPdfReport': 'Pdfレポートをダウンロード',
            'yesterday': '昨日',
            'totalOrders': '合計注文',
            'totalVisitors': '総訪問者',
            'typeYourQuestions': 'あなたの質問を入力してください',
            'username': 'ユーザー名',
            'password': 'パスワード',
            'signIn': 'サインイン',
            'enterYourPassword': 'パスワードを入力してください',
            'alreadyHavingAccountLogin': 'すでにアカウントにログインしている',
            'composeMail': 'メールを作成する',
            'issue': '問題',
            'recentChat': '最近のチャット',
            'previousChat': '前のチャット',
            'all': 'すべて',
            'filters': 'フィルタ',
            'deleted': '削除済み',
            'starred': 'スター付き',
            'frontend': 'フロントエンド',
            'backend': 'バックエンド',
            'api': 'Api',
            'simpleAppBar': 'シンプルなアプリケーションバー',
            'recents': '過去',
            'cardLink': 'カードリンク',
            'anotherLink': '別のリンク',
            'cardSubtitle': 'カード字幕',
            'confirmationDialogs': '確認ダイアログ',
            'deletableChip': '削除可能なチップ',
            'customDeleteIconChip': 'カスタム削除アイコンチップ',
            'openAlertDialog': '警告ダイアログを開く',
            'openResponsiveDialog': '応答ダイアログを開く',
            'openSimpleDialog': 'シンプルダイアログを開く',
            'openFormDialog': 'フォームダイアログを開く',
            'follower': 'フォロワー',
            'important': '重要',
            'private': 'プライベート',
            'openLeft': '左開き',
            'openRight': '右に開く',
            'openTop': 'オープントップ',
            'openBottom': 'オープンボトム',
            'selectTripDestination': '旅行先を選択',
            'pinnedSubheaderList': '固定されたサブヘッダリスト',
            'singleLineItem': '単品商品',
            'acceptTerms': '受諾条件',
            'optionA': 'オプションA',
            'optionB': 'オプションB',
            'optionC': 'オプションC',
            'optionM': 'オプションM',
            'optionN': 'オプションN',
            'optionO': 'オプションO',
            'customColor': 'カスタムカラー',
            'centeredTabs': '中央のタブ',
            'multipleTabs': '複数のタブ',
            'preventScrolledButtons': 'スクロールボタンの防止',
            'browse': 'ブラウズ',
            'formValidate': 'フォームの検証',
            'code': 'コード',
            'company': '会社',
            'price': '価格',
            'change': '変化する',
            'high': '高い',
            'low': '低い',
            'volume': 'ボリューム',
            'personalDetails': '個人情報',
            'occupation': '職業',
            'companyName': '会社名',
            'phoneNo': '電話番号',
            'city': 'シティ',
            'zipCode': '郵便番号',
            'updateProfile': 'プロフィールを更新',
            'reject': '拒否',
            'exportToExcel': '優れたにエクスポート',
            'addNewUser': '新しいユーザーを追加',
            'workWeek': 'ワークウィーク',
            'agenda': '議題',
            'conference': '会議',
            'multilevel': 'マルチレベル',
            'dailySales': '毎日の販売',
            'today': '今日',
            'campaignPerformance': 'キャンペーンの掲載結果',
            'supportRequest': 'サポートリクエスト',
            'usersList': 'ユーザーリスト',
            'lastWeek': '先週',
            'buyMore': 'もっと買う',
            'trafficChannel': 'トラフィックチャネル',
            'stockExchange': '証券取引所',
            'tweets': 'ツイート',
            'ourLocations': '私たちの場所',
            'sales': '販売',
            'to': 'に',
            'shipTo': '送り先',
            'description': '説明',
            'unitPrice': '単価',
            'total': '合計',
            'note': '注意',
            'chipWithAvatar': 'アバターのチップ',
            'chipWithTextAvatar': 'テキストアバターチップ',
            'chipWithIconAvatar': 'アイコンアバターのチップ',
            'customClickableChip': 'カスタムクリック可能チップ',
            'outlineChip': 'アウトラインチップ',
            'disableChip': 'チップを無効にする',
            'alertDialog': '警告ダイアログ',
            'animatedSlideDialogs': 'アニメーションスライドダイアログ',
            'fullScreenDialogs': '全画面ダイアログ',
            'formDialogs': 'フォームダイアログ',
            'simpleDialogs': 'シンプルなダイアログ',
            'responsiveFullScreen': 'レスポンシブフルスクリーン',
            'primary': '一次',
            'social': 'ソーシャル',
            'user': 'ユーザー',
            'admin': '管理者',
            'permanentdrawer': '常設引き出し',
            'persistentdrawer': '永続的引き出し',
            'swiches': 'スウィッチ',
            'horizontalLinearAlternativeLabel': '水平線形代替ラベル',
            'horizontalNonLinearAlternativeLabel': '水平非線形代替ラベル',
            'notifications': '通知',
            'basicAlert': '基本的な警告',
            'successAlert': '成功の警告',
            'warningAlert': '警告アラート',
            'reactAutoSuggest': '自動提案に反応する',
            'components': 'コンポーネント',
            'inputAdornments': '入力アドライト',
            'multiSelectList': 'マルチセレクトリスト',
            'contextualColoredTable': 'コンテクスチャカラーテーブル',
            'updateYourEmailAddress': 'あなたのメールアドレスを更新する',
            'selectADefaultAddress': 'デフォルトアドレスを選択',
            'activity': 'アクティビティ',
            'basicCalendar': '基本カレンダー',
            'culturesCalendar': 'カルチャーカレンダー',
            'dragAndDropCalendar': 'ドラッグアンドドロップカレンダー',
            'quillEditor': 'クイルエディタ',
            'reactDND': '反応dnd',
            'dragula': 'ドラッグラ',
            'AcceptorrRejectWithin': '以内に同意または拒否する',
            'quoteOfTheDay': '今日の名言',
            'updated10Minago': '1時間前に更新されました',
            'personalSchedule': '個人のスケジュール',
            'activeUsers': 'アクティブユーザー',
            'totalRequest': '総リクエスト',
            'new': '新しい',
            'ShareWithFriends': '友人たちと分ける！',
            'helpToShareText': '私たちのウェブサイトをあなたの友人やソーシャルメディアのフォロワーと共有することで、世界を広げるお手伝いをしてください！',
            'thisWeek': '今週',
            'howWouldYouRateUs': 'どのように評価しますか？',
            'booking': '予約',
            'confirmed': '確認済み',
            'monthly': '毎月',
            'weekly': 'ウィークリー',
            'target': 'ターゲット',
            'totalActiveUsers': '総アクティブユーザー数',
            'deadline': '締め切り',
            'team': 'チーム',
            'projectManagement': 'プロジェクト管理',
            'latestPost': '最新の投稿',
            'projectTaskManagement': 'プロジェクトタスク管理',
            'selectProject': 'プロジェクトを選択',
            'activityBoard': 'アクティビティボード',
            'checklist': 'チェックリスト',
            'baseConfig': '基本構成',
            'customControlBar': 'カスタムコントロールバー',
            'withDownloadButton': 'ダウンロードボタン付き',
            'httpLiveStreaming': 'HTTPライブストリーミング',
            'keyboardShortcuts': 'キーボードショートカット',
            'preview': 'プレビュー',
            'croppedImage': 'クロップド画像',
            'transactionList': '取引リスト',
            'transferReport': '振替レポート',
            'expenseCategory': '経費カテゴリ',
            'upcomingEvents': '今後のイベント',
            'OngoingProjects': '進行中のプロジェクト',
            'ProjectStatus': 'プロジェクト状況',
            'LiveChatSupport': 'ライブチャットのサポート'
        },
        'components': {
            'buyNow': '今買う',
            'alreadyHavingAccountSignIn': 'すでにアカウントにサインインしている',
            'enterYourPassword': 'パスワードを入力してください',
            'unlock': 'ロックを解除する',
            'enterPasswords': 'パスワードを入力',
            'resetPassword': 'パスワードの再入力',
            'pageNotfound': 'ページが見つかりません',
            'goToHomePage': 'ホームページへ',
            'sorryServerGoesWrong': '申し訳ありませんが、サーバーが間違っています',
            'persistentDrawer': '永続的引き出し',
            'back': 'バック',
            'next': '次',
            'completeStep': '完全なステップ',
            'withHtml': 'HTMLで',
            'prompt': 'プロンプト',
            'withDescription': '説明付き',
            'success': '成功',
            'passwordPrompt': 'パスワードプロンプト',
            'warning': '警告',
            'customIcon': 'カスタムアイコン',
            'customStyle': 'カスタムスタイル',
            'basic': 'ベーシック',
            'submit': '提出する',
            'compose': '作成する',
            'sendMessage': 'メッセージを送る',
            'addNewTasks': '新しいタスクを追加する',
            'addToCart': 'カートに追加',
            'payNow': '今払う',
            'print': '印刷',
            'cart': 'カート',
            'viewCart': 'かごの中身を見る',
            'checkout': 'チェックアウト',
            'summary': '概要',
            'yesterday': '昨日',
            'last7Days': '過去7日間',
            'last1Month': '過去1ヶ月',
            'last6Month': '過去6ヶ月',
            'spaceUsed': '使用されたスペース',
            'followers': 'フォロワー',
            'trending': 'トレンド',
            'paid': '有料',
            'refunded': '払い戻された',
            'done': '完了',
            'pending': '保留中',
            'cancelled': 'キャンセル',
            'approve': '承認する',
            'week': '週間',
            'month': '月',
            'year': '年',
            'today': '今日',
            'popularity': '人気',
            'email': 'Eメール',
            'drafts': '下書き',
            'sent': '送信済み',
            'trash': 'ごみ',
            'all': 'すべて',
            'do': '行う',
            'title': 'タイトル',
            'projectName': 'プロジェクト名',
            'companyName': '会社名',
            'openAlert': 'オープンアラート',
            'slideInAlertDialog': '警告ダイアログでスライド',
            'openFullScreenDialog': 'フルスクリーンダイアログを開く',
            'basicChip': '基本チップ',
            'clickableChip': 'クリック可能なチップ',
            'left': '左',
            'right': '右',
            'expansionPanel1': '拡張パネル1',
            'expansionPanel2': '拡張パネル2',
            'generalSetting': '一般的な設定',
            'advancedSettings': '高度な設定',
            'firstName': 'ファーストネーム',
            'lastName': '苗字',
            'occupation': '職業',
            'phoneNo': '電話番号',
            'address': '住所',
            'city': 'シティ',
            'state': '状態',
            'zipCode': '郵便番号',
            'social Connection': 'ソーシャルコネクション',
            'emailPrefrences': 'メールの設定',
            'myProfile': '私のプロフィール',
            'product': '製品',
            'quantity': '量',
            'totalPrice': '合計金額',
            'removeProduct': '製品を削除する',
            'mobileNumber': '携帯電話番号',
            'address2Optional': '住所2（オプション）',
            'country': '国',
            'zip': 'ジップ',
            'saveContinue': '保存して続行',
            'placeOrder': '注文する',
            'payment': '支払い',
            'billingAddress': '請求先住所',
            'ShippingAddressText': '配送先住所は請求先住所と同じです。',
            'CartEmptyText': 'ショッピングカートは空です！',
            'NoItemFound': 'アイテムが見つかりません',
            'goToShop': '店へ出かける',
            'cardNumber': 'カード番号',
            'expiryDate': '有効期限',
            'cvv': 'CVV',
            'nameOnCard': 'カード上の名前',
            'confirmPayment': 'お支払いの確認'
        },
        'compenets': {
            'choose': '選択する',
            'username': 'ユーザー名',
            'passwords': 'パスワード',
            'signIn': 'サインイン',
            'dontHaveAccountSignUp': 'アカウントのサインアップはありません',
            'enterUserName': 'ユーザーネームを入力してください',
            'enterEmailAddress': 'メールアドレスを入力してください',
            'confirmPasswords': 'パスワードの確認'
        },
        'themeOptions': {
            'sidebarOverlay': 'サイドバーオーバーレイ',
            'sidebarBackgroundImages': 'サイドバーの背景イメージ',
            'appSettings': 'アプリの設定',
            'sidebarImage': 'サイドバー画像',
            'miniSidebar': 'ミニサイドバー',
            'boxLayout': 'ボックスレイアウト',
            'rtlLayout': 'RTLレイアウト',
            'darkMode': 'ダークモード',
            'sidebarLight': '光',
            'sidebarDark': 'ダーク',
            'themeColor': 'テーマカラー'
        },
        'button': {
            'cancel': 'キャンセル',
            'add': '追加',
            'update': '更新',
            'reply': '応答',
            'delete': '削除',
            'yes': 'はい',
            'viewAll': 'すべて見る',
            'like': '好き',
            'assignNow': '今すぐ割り当て',
            'seeInsights': 'インサイトを見る',
            'acceptTerms': '受諾条件',
            'reject': '拒否',
            'addNew': '新しく追加する',
            'goToCampaign': 'キャンペーンへ移動',
            'viewProfile': 'プロフィールを見る',
            'sendMessage': 'メッセージを送る',
            'saveNow': '今すぐ保存',
            'pen': 'ペン',
            'search': 'サーチ',
            'downloadPdfReport': 'pdfレポートをダウンロード',
            'primary': '一次',
            'secondary': '二次',
            'danger': '危険',
            'info': '情報',
            'success': '成功',
            'warning': '警告',
            'link': 'リンク',
            'smallButton': '小さなボタン',
            'largeButton': '大きなボタン',
            'blockLevelButton': 'ブロックレベルボタン',
            'primaryButton': 'プライマリボタン',
            'button': 'ボタン',
            'save': 'セーブ',
            'openMenu': 'メニューを開く',
            'openWithFadeTransition': 'フェードトランジションで開く',
            'openPopover': 'オープン・ポップ・オーバー',
            'accept': '同意する',
            'click': 'クリック',
            'complete': 'コンプリート',
            'back': 'バック',
            'next': '次',
            'completeStep': '完全なステップ',
            'error': 'エラー',
            'writeNewMessage': '新しいメッセージを書く',
            'saveChanges': '変更内容を保存',
            'addNewUser': '新しいユーザーを追加',
            'more': 'もっと',
            'useDefaultImage': 'デフォルト画像を使用する',
            'cropImage': 'クロップ画像'
        },
        'hint': {
            'whatAreYouLookingFor': '何を探していますか',
            'searchMailList': 'メールリストを検索'
        },
        'module': {
            'inbox': '受信トレイ',
            'drafts': '下書き',
            'sent': '送信済み',
            'trash': 'ごみ',
            'spam': 'スパム',
            'frontend': 'フロントエンド',
            'backend': 'バックエンド',
            'api': 'Api',
            'issue': '問題'
        },
        'documents': {},
        'common': {},
        'logout': {},
        'login': {},
        'actions': {},
        'sign_up': {}
    }
};